import {FormConfig} from "../../form/form.config";
import {FormModel} from "../../form/form.model.abstract";
import {FormModelRadio} from "../../form/form.model.radio";
import {FormModelCheckboxes} from "../../form/form.model.checkboxes";
import {Validators} from "@angular/forms";
import {FormModelText} from "../../form/form.model.text";
import {ValidationService} from "../../services/validation.service";
import {StepComponent} from "../../step/step.component";
import {FoerdermittelcheckAnfrage} from "../anfrage/foerdermittelcheck.anfrage";


/**
 * Configuratuion for the input of the first chapter in the foerdermittelcheck advisor.
 * @inheritDoc
 */

export class EingabeForm extends FormConfig {

  /**
   * some data is needed here for validation
   */
  public anfrage: FoerdermittelcheckAnfrage;

  /**
   * (input) data of the user
   */
  stepComponent: StepComponent;

  /**
   * @inheritDoc
   * @protected
   *
   */

  protected fields: FormModel[] = [
    //basisinformationen
    new FormModelRadio('foerdernehmer', ['privatperson', 'unternehmen', 'kommune'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeudetyp', ['1-2familienhaus', 'mehrfamilienhaus', 'nichtwohngebaeude'], [Validators.required], null, null, false),
    (new FormModelText('postleitzahl', [Validators.required, ValidationService.postalCode], null, null, false)).setClasses('small-field'),
    (new FormModelText('gebaeude_baujahr', [Validators.required, ValidationService.buildingYear], null, null, false, 'number')).setClasses('small-field'),
    new FormModelRadio('heizungstyp', ['zentralheizung', 'etagenheizung', 'einzeloefen'], [Validators.required], null, null, false),
    new FormModelRadio('energietraeger', ['erdgas', 'heizoel', 'strom', 'holzpellets', 'hackschnitzel', 'scheitholz', 'fernwaerme', 'fluessiggas', 'waermepumpe', 'waermepumpe_luft', 'waermepumpe_wasser'], [Validators.required], null, null, false),
    new FormModelRadio('gebaeude_nutzung', ['eigennutzung', 'fremdvermietung'], [Validators.required], null, null, false),

    //massnahmen
    new FormModelCheckboxes('insulation', [], [], null, null, false),
    new FormModelCheckboxes('heatingsystem', [], [], null, null, true),
    new FormModelCheckboxes('heating_optimization', [], [], null, null, true),
    new FormModelCheckboxes('additional_systems', [], [], null, null, false),
    new FormModelCheckboxes('additional_measures', [], [], null, null, false),
    new FormModelCheckboxes('energetic_optimization', [], [], null, null, true),
    new FormModelCheckboxes('energy_efficiency', [], [], null, null, true),
    new FormModelCheckboxes('electric_mobility', [], [], null, null, true),
    (new FormModelRadio('heating', [], [], null, null, true)).setInactive(),
    (new FormModelRadio('solar_thermal_energy', [], [], null, null, false)).setInactive(),
    (new FormModelCheckboxes('refrigeration_system', [], [], null, null, false)).setInactive()
  ];

  public measureFields: any = ['additional_measures', 'additional_systems', 'electric_mobility', 'energetic_optimization',
                  'energy_efficiency', 'heating_optimization', 'heatingsystem', 'insulation'];

  public basicFields: string[] = ['foerdernehmer', 'gebaeudetyp', 'postleitzahl', 'gebaeude_baujahr', 'heizungstyp',
                  'energietraeger', 'gebaeude_nutzung'];

  /**
   * @inheritDoc
   * @protected
   */
  protected groups: any = {
    'foerdernehmer/basisinformationen/1': ['foerdernehmer'],
    'foerdernehmer/basisinformationen/2': ['gebaeudetyp'],

    'gebaeude/basisinformationen/3': ['postleitzahl'],
    'gebaeude/basisinformationen/4': ['gebaeude_baujahr'],
    'gebaeude/basisinformationen/5': ['heizungstyp'],
    'gebaeude/basisinformationen/6': ['energietraeger'],

    'nutzung/basisinformationen/7': ['gebaeude_nutzung'],

    'massnahmen/insulation': ['insulation'],
    'massnahmen/heating': ['heating'],
    'massnahmen/solar_thermal_energy': ['solar_thermal_energy'],
    'massnahmen/refrigeration_system': ['refrigeration_system'],

    'zusatzmassnahmen/heating_optimization': ['heating_optimization'],
    'zusatzmassnahmen/additional_systems': ['additional_systems'],
    'zusatzmassnahmen/additional_measures': ['additional_measures'],

    'energie/energetic_optimization': ['energetic_optimization'],
    'energie/energy_efficiency': ['energy_efficiency'],
    'energie/electric_mobility': ['electric_mobility'],

  };

  /**
   * The options for some fields that are dynamic, depending on other form fields
   */
  static readonly options: any = {
    'gebaeudetyp': {
      'privatperson': ['1-2familienhaus', 'mehrfamilienhaus', 'eigentumswohnung', 'nichtwohngebaeude'],
    },
    'heizungstyp': {
      '1-2familienhaus': ['zentralheizung', 'einzeloefen'],
      'nichtwohngebaeude': ['zentralheizung']
    },
    'energietraeger': {
      'etagenheizung': ['erdgas'],
      'einzeloefen': ['erdgas', 'heizoel', 'strom', 'holzpellets', 'hackschnitzel', 'scheitholz']
    }
  };

  /**
   * Special order of options for the step 'heating'
   * @protected
   */
  protected orderHeatingOptions = ['waermepumpe_unspezifisch', 'fernwaerme', 'biomasse_scheitholz', 'biomasse_holzpellets', 'biomasse_hackschnitzel', 'brennstoffzelle', 'bhkw', 'erneuerbare_hybrid', 'erneuerung_heizung', 'umstellung_fluessiggas', 'umstellung_erdgas'];


  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: { [key: string]: any }): any {
    // changes based on field 'gefoerdertWird'
    if(this.anfrage?.gefoerdertWird?.length === 1) {
      if(this.anfrage?.gefoerdertWird?.includes('elektromobilitaet')) {
        this.deactivateField('gebaeude_nutzung');
        values.gebaeude_nutzung = null;
      }
      else {
        this.activateField('gebaeude_nutzung');
      }
    }

    //changes based on input 'altbau'
    if(this.anfrage?.gefoerdertWird?.length >= 1) {
      if(this.anfrage?.gefoerdertWird?.includes('altbau')) {
        this.activateField('gebaeude_baujahr');
        this.activateField('heizungstyp');
        this.activateField('energietraeger');

        //changes based on 'gebaeudetyp'
        if(values.hasOwnProperty('gebaeudetyp')) {
          if(values.gebaeudetyp === "1-2familienhaus") {
            //set to null when option not displayed
            if(values.heizungstyp === 'etagenheizung') {
              values.heizungstyp = null;
            }
            this.setOptions('heizungstyp', EingabeForm.options.heizungstyp['1-2familienhaus']);
          }
          if(values.gebaeudetyp === 'nichtwohngebaeude') {
            //only one option, so we deactivate the field heizungstyp and set the value
            this.deactivateField('heizungstyp');
            values.heizungstyp = 'zentralheizung';
          }
          else {
            this.activateField('heizungstyp');
          }
        }

        //changes based on 'heizungstyp'
        if(values.hasOwnProperty('heizungstyp')) {
          if(values.heizungstyp === 'etagenheizung') {
            //only one option, so we deactivate the field energietraeger and set the value
            this.deactivateField('energietraeger');
            values.energietraeger = 'erdgas';
          }
          else {
            this.activateField('energietraeger');
          }
          if(values.heizungstyp === 'einzeloefen') {
            this.setOptions('energietraeger', EingabeForm.options.energietraeger['einzeloefen']);
          }
        }
      }
      else {
        this.deactivateField('gebaeude_baujahr');
        this.deactivateField('heizungstyp');
        this.deactivateField('energietraeger');
        values.gebaeude_baujahr = null;
        values.heizungstyp = null;
        values.energietraeger = null;
      }
    }

    // changes based on field 'foerdernehmer'
    if(values.hasOwnProperty('foerdernehmer')) {
      if(values.foerdernehmer === 'privatperson') {
        this.setOptions('gebaeudetyp', EingabeForm.options.gebaeudetyp['privatperson']);
      }
    }

    if(this.anfrage.measures) {
      // reset measure mapping
      this.anfrage.measuresMapping = {};

      this.measureFields.forEach(fieldName => {
        if(this.anfrage.measures.hasOwnProperty(fieldName)) {

          const fieldOptions = Object.keys(this.anfrage.measures[fieldName]);

          // check if fieldoptions are grouped
          const fieldOptionGroups = {};
          fieldOptions.forEach(fieldOption => {
            const groupName = this.anfrage.measures[fieldName][fieldOption]["group"]?? null;

            if(groupName !== null) {
              if(fieldOptionGroups.hasOwnProperty(groupName) === false) {
                fieldOptionGroups[groupName] = [];
              }
              fieldOptionGroups[groupName].push(fieldOption);
            }

          })

          if(Object.keys(fieldOptionGroups).length === 0) {
            // case 1: checkboxes
            // activate field
            this.activateField(fieldName);
            // set options
            const filteredFieldOptions = fieldOptions.filter((options) => fieldName !== 'additional_systems' || (fieldName === 'additional_systems' && options !== 'kaeltetechnik'));
            this.setOptions(fieldName, filteredFieldOptions);

            // add measure to mesauremapping
            this.anfrage.measuresMapping[fieldName] = filteredFieldOptions.map(option => fieldName + '_' + option);

            // set values
            const fieldValues = filteredFieldOptions.map(option => this.anfrage.userInput[fieldName + '_' + option] === true);
            const field = <FormModelCheckboxes>this.getField(fieldName);
            field.setValues(fieldValues);

            // update form
            this.addFieldToForm(this.form, field, false);

            //special case: put option kaeltetechnik on extra step
            if(fieldName === 'additional_systems' && fieldOptions.includes('kaeltetechnik')){
              //activate new field refrigeration_system with option kaeltetechnik
              this.activateField('refrigeration_system');
              this.setOptions('refrigeration_system', ['kaeltetechnik']);

              //add kaeltetechnik to measure mapping
              this.anfrage.measuresMapping[fieldName].push('refrigeration_system_kaeltetechnik');

              //set values for kaeltetechnik
              const field = <FormModelCheckboxes>this.getField('refrigeration_system');
              field.setValues([this.anfrage.userInput['refrigeration_system_kaeltetechnik'] === true]);

              //update form
              this.addFieldToForm(this.form, field, false);
            }

          }
          else {
            // init measuremapping for this group
            this.anfrage.measuresMapping[fieldName] = [];

            // case 2: radios
            Object.keys(fieldOptionGroups).forEach(groupedFieldName => {
              // activate field
              this.activateField(groupedFieldName);

              // add measure to mesauremapping
              this.anfrage.measuresMapping[fieldName].push(groupedFieldName)

              // set options
              if(fieldOptionGroups['heating']) {
                // set different order of options for step 'heating'
                const changedOrder = this.changeOptionsOrder(fieldOptionGroups['heating'], this.orderHeatingOptions);
                changedOrder.push('none');
                this.setOptions('heating', changedOrder);
              }
              const options = fieldOptionGroups[groupedFieldName];
              options.push('none');
              this.setOptions(groupedFieldName, options);
            });
          }


        }
        else {
          // deativate field
          this.deactivateField(fieldName);
        }
      });
    }

    //set heating value to false when no selection
    if(values.hasOwnProperty('heating')) {
      if(values.heating === 'none') {
        values.heating = false;
      }
    }

    //set solar_thermal_energy value to false when no selection
    if(values.hasOwnProperty('solar_thermal_energy')) {
      if(values.solar_thermal_energy === 'none') {
        values.solar_thermal_energy = false;
      }
    }



    return values;
  }


  /**
   * Sets stepComponent
   * @param stepComponent
   */
  setStepComponent(stepComponent: StepComponent): void {
    this.stepComponent = stepComponent;
  }

  /**
   * Change the order of options
   * @param optionsFromApi
   * @param changedOptions
   */
  changeOptionsOrder(optionsFromApi: any[], changedOptions: string[]) {
    // return only the changedOptions if they are in optionsFromApi
    return changedOptions.map(changedOption => optionsFromApi.find(option => option === changedOption)).filter(option => option !== undefined);
  }

}
